export const scrollToElement = (id: string) => {
    const el = document.getElementById(id)
    
    if (!el) {
        return
    }

    el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    })
}